const ONDE_TREINA = [
	{ value: 'casa', label: 'Em casa' },
	{ value: 'academia', label: 'Academia' }
];

export default ONDE_TREINA;



// WEBPACK FOOTER //
// ./src/data/Onde_treina.js